/**
 * Resolves icon component for a preference type id.
 *
 * Belongs here: icon lookup by type + image availability.
 * Does not belong here: API fetch.
 */
import React, { useState } from 'react'
import type { CategoryIconProps } from '../../../../../icons/CategorySvgIcon'
import { mfLogoBaseUrl } from '../../../../../env'
import { getPreferenceTypeStrategyIconPath } from '../setup/preferenceTypeUtils'
import { FallbackPreferenceIcon } from './icons/PreferenceTypeIcons'
import { ImageAvailability } from '../../shared/types/common.types'

/** Full CDN URL for a preference type strategy icon (others path when unmapped). */
export function getPreferenceTypeIconImageUrl(preferenceTypeId: string): string {
  return `${mfLogoBaseUrl}${getPreferenceTypeStrategyIconPath(preferenceTypeId)}`
}

/**
 * Returns the icon component for a preference type.
 * Uses hardcoded strategy CDN paths; unmapped ids use the others icon.
 */
export function getPreferenceTypeIcon(
  preferenceTypeId: string,
  availability: ImageAvailability = ImageAvailability.UNKNOWN
): React.FC<CategoryIconProps> {
  if (availability === ImageAvailability.UNAVAILABLE) return FallbackPreferenceIcon

  const imagePath = getPreferenceTypeIconImageUrl(preferenceTypeId)

  const IconWithFallback: React.FC<CategoryIconProps> = (props) => {
    const [failed, setFailed] = useState(false)
    if (failed) return <FallbackPreferenceIcon {...props} />
    return (
      <img
        src={imagePath}
        alt=""
        className={props.className}
        onError={() => setFailed(true)}
      />
    )
  }
  return IconWithFallback
}
